import React from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from '../../../../CommonComponents/Highcharts';
import { createCustomPropType, isNumeric, isUuid } from '../../../../../js/app/react/validators';

import { computeChartStringKey } from '../../../../FinancialPlan/Insurance/Disability/ProgressChart/ProgressChartHelpers';

const MobileProgressChartView = ({
  chartData, ownerIndex, subgoalId, fpId, clientId,
}) => (
  <div className="NewFinancialPlan_Insurance_DisabilityChart mobile">
    <ReactHighcharts
      container={computeChartStringKey(ownerIndex.toString(), `${subgoalId}`, fpId, clientId)}
      autoResize
      className="progress-chart"
      options={chartData}
    />
  </div>
);

MobileProgressChartView.propTypes = {
  chartData: PropTypes.shape({}).isRequired,
  ownerIndex: PropTypes.number.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  subgoalId: PropTypes.string.isRequired,
};

export default MobileProgressChartView;
